<template>
  <article class="view-invoice-page">
    <div class="heading">
      <AppLogo class="heading-logo"></AppLogo>
      <div class="heading-text-group">
        <div class="heading-caption">
          Địa chỉ: Mường Sang - Mộc Châu - Sơn La
        </div>
        <div class="heading-caption-group">
          <div class="heading-caption">Tel: 1900 2829</div>
          <div class="divider vertical"></div>
          <div class="heading-caption">Fax: 0212 3768 768</div>
        </div>
        <div class="heading-caption-group">
          <div class="heading-caption">Email: info@mocchau.com</div>
          <div class="divider vertical"></div>
          <div class="heading-caption">Website: mocchauisland.com</div>
        </div>
      </div>
    </div>
    <div class="hr"></div>
    <div class="title-form">
      <h1 class="heading-title">Phiếu đăng kí</h1>
      <div class="heading-caption">
        Mã đặt phòng: {{ bookingDetail.booking_code }}
      </div>
    </div>
    <div class="section section-guest-info">
      <h2>I. Thông tin khách</h2>
      <div>
        <div class="invoice-info-item">
          <span class="item-label">Công ty: </span
          >{{ bookingDetail.company ?? '' }}
        </div>
        <div class="invoice-info-item">
          <span class="item-label">Tên khách: </span
          >{{ bookingDetail.customer_name ?? '' }}
        </div>
        <div class="invoice-info-item">
          <span class="item-label">Địa chỉ: </span
          >{{ bookingDetail.address ?? '' }}
        </div>
        <div class="invoice-info-item">
          <span class="item-label">Email: </span>{{ bookingDetail.email ?? '' }}
        </div>
      </div>
    </div>
    <div class="hr"></div>
    <div class="section section-reservation-table">
      <h2>II. Thông tin đặt phòng</h2>

      <table class="table-reservation">
        <thead>
          <tr>
            <th>STT</th>
            <th>Ngày Checkin</th>
            <th>Ngày Checkout</th>
            <th>Hạng phòng</th>
            <th>Số phòng</th>
            <th>Phòng</th>
            <!-- <th class="text-right">Tổng</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(room, index) in bookingDetail.rooms" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ room?.ci_date }}</td>
            <td>{{ room?.co_date }}</td>
            <td>{{ room?.room_level }}</td>
            <td>{{ room?.num_of_room }}</td>
            <td>{{ room?.room_num }}</td>
          </tr>
        </tbody>
      </table>
      <div class="guide">
        <p>Giá phòng đã bao gồm các dịch vụ và tiện ích sau:</p>
        <ul>
          <li>Ăn sáng cho 02 khách tại nhà hàng</li>
          <li>Truy cập internet tốc độ cao miễn phí Wifi/Lan</li>
          <li>Sử dụng hồ bơi ngoài trời</li>
          <li>
            Miễn phí nước uống (1 chai/một khách), trà, café mỗi ngày cho tất cả
            các phòng
          </li>
        </ul>
      </div>
    </div>
    <div class="hr"></div>
    <div class="section section-payment-table">
      <h2>III. Thông tin thanh toán</h2>

      <p>
        Đặt cọc:
        {{ deposit }}
        VND
      </p>
    </div>
    <div class="section-signature">
      <div style="margin-top: 25px">
        <span>Chữ ký thu ngân</span>
      </div>
      <div>
        <p>Mộc Châu, {{ $moment().format('DD/MM/YYYY') }}</p>
        <span>Chữ ký khách hàng</span>
      </div>
    </div>
  </article>
</template>
<script>
/* eslint-disable */
import { getRegisterFormApi } from '@/api/booking_service/bookingGroup'
import { displayCurrency } from '@/utils/helper'
import { getUserDetailApi } from '@/api/profile/profile'
import AppLogo from '@/components/AppLogo.vue'
export default {
  components: {
    AppLogo
  },

  data() {
    return {
      bookingId: null,
      type: null,
      recodeGroup: null,
      subBookingId: null,
      printer: null,
      deposit: null,
      bookingDetail: {
        booking_code: null,
        customer_name: null,
        company: null,
        deposit: null,
        email: null,
        rooms: []
      },

      payments: {
        cash: {
          name: 'Tiền mặt',
          amount: null
        },
        card: {
          name: 'Thẻ',
          amount: null
        },
        bank_transfer: {
          name: 'Chuyển khoản',
          amount: null
        },
        foc: {
          name: 'Miễn phí',
          amount: null
        },
        debt: {
          name: 'Công nợ',
          amount: null
        }
      }
    }
  },
  async mounted() {
    this.bookingId = this.$route.query.id
    this.type = +this.$route.query.type

    // this.customerInfo.company = this.$route.query.company
    // this.customerInfo.from = this.$route.query.from
    // this.customerInfo.to = this.$route.query.to
    // this.customerInfo.address = this.$route.query.address
    await getRegisterFormApi({
      code: this.bookingId,
      type: this.type
    }).then(res => {
      this.bookingDetail = { ...res.data }
      this.deposit = this.bookingDetail.deposit
        ? displayCurrency(this.bookingDetail.deposit)
        : 0
    })

    await getUserDetailApi().then(res => {
      this.printer = res.data.user
    })

    this.$nextTick(() => {
      window.print()
    })
  }
}
</script>
<style>
@media print {
  * {
    overflow: visible !important;
  }
  .view-invoice-page {
    max-width: unset;
  }
}
</style>
<style lang="scss" scoped>
.title-form {
  .heading-title {
    text-align: center;
  }
  .heading-caption {
    text-align: center;
    color: black;
    font-size: 12pt;
  }
}
.section {
  h2 {
    font-size: 14pt;
  }
  .guide {
    padding: 20pt 0 0;
    p {
      margin: 10pt 0;
    }
    ul {
      padding: 0 16pt;
      margin: 0;
    }
  }
}

.view-invoice-page {
  max-width: 200mm;
  margin: 0 auto;
}
.divider.vertical {
  height: 10pt;
  flex-shrink: 0;
  width: 0;
  border-left: 1px solid rgb(156 163 175);
}

.heading-title {
  margin: 0;
  margin-bottom: 8pt;
  font-size: 20pt;
  font-weight: 600px;
  text-transform: uppercase;
}
.heading-caption-group {
  display: flex;
  margin-top: 4pt;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  gap: 6pt;
}
.heading-caption {
  color: rgb(156 163 175);
}
.heading-text-group {
  text-align: center;
  height: fit-content;
}
.heading {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.heading-logo {
  height: 120pt;
  width: auto;
}
.hr {
  margin-top: 16pt;
  margin-bottom: 16pt;
  border-top: 0.5pt solid #e5e7eb !important;
}

.invoice-info-item {
  display: block;
  margin-top: 0.5rem;
}

.invoice-info-item .item-label {
  font-weight: 600;
}

.invoice-info-item:first-child {
  margin-top: 0;
}
td {
  max-width: 150px;
}
/* Hide scrollbars */
body {
  overflow: hidden !important;
}
table,
td,
th,
tr,
thead {
  border: none !important;
}
* {
  font-size: 12pt;
}
thead th {
  font-weight: 500;
}

table td,
table th {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.section-invoice-info {
  display: grid;
  grid-template-columns: 75% 25%;
}
.section-invoice-info-right {
  text-align: right;
}
.invoice-info-item {
  display: block;
  margin-top: 0.5rem;
}

.invoice-info-item .item-label {
  font-weight: 600;
}

.invoice-info-item:first-child {
  margin-top: 0;
}
.section-signature {
  page-break-inside: avoid;
  min-height: 80pt;
  margin-top: 30pt;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  p {
    padding: 0;
    margin: 0 0 5px;
    height: 20px;
    font-size: 11pt;
    font-style: italic;
  }
}

.section-summary td {
  border: none;
  padding-top: 0 !important;
}

.section-summary tr:last-child td {
  padding-bottom: 0 !important;
}

.section-summary {
  width: fit-content;
  margin-left: auto;
}
table td.text-right,
table th.text-right {
  text-align: right;
}
table th {
  color: black;
  text-align: left;
  border: none;
}
table thead {
  background-color: unset;
}

table td:last-child {
  padding-right: 0 !important;
}
.section-summary td:first-child {
  font-weight: 500;
  font-size: 10pt;
  text-align: right;
}

.section-summary td:last-child {
  text-align: right;
  padding-left: 20pt !important;
}
.table-payments,
.table-transactions {
  border-collapse: collapse;
}
.table-payments td,
.table-transactions td,
.table-payments th,
.table-transactions th {
  border: 1px solid black !important;
  padding: 6pt !important;
}
.table-transactions .text-right,
.table-payments .text-right {
  text-align: right;
}
.table-transactions td:last-child,
.table-payments td:last-child {
  padding-right: 6pt !important;
}
</style>
